import { useEffect } from 'react';
import { useConfig } from '../config/ConfigContext';
import { KeycloakProvider } from '../auth/KeycloakProvider';
import { RouterProvider, useRouter } from './Router';
import TopNav from '../components/TopNav';
import MarketplacePage from '../pages/MarketplacePage';
import DashboardPage from '../pages/DashboardPage';
import AdminPage from '../pages/AdminPage';
import { t } from '../i18n';
import type { Route } from './Router';

function ShellContent() {
  const config = useConfig();
  const { route, navigate, previewState } = useRouter();

  useEffect(() => {
    document.title = config.instance.name;
  }, [config.instance.name]);

  const isPreview = route.startsWith('/preview/');
  const effectiveRoute: Route = isPreview ? '/' : route;

  const isAdminRoute =
    effectiveRoute === '/admin' || effectiveRoute === '/admin/sub-clients';

  return (
    <div className="dp-shell">
      <TopNav activePath={effectiveRoute} onNavigate={navigate} />

      {/* Dev preview banner */}
      {import.meta.env.DEV && isPreview && (
        <div
          style={{
            background: 'var(--dp-navy-800)',
            color: 'var(--fg-on-navy)',
            fontFamily: 'var(--font-mono)',
            fontSize: 'var(--fs-meta)',
            padding: '4px var(--sp-8)',
            textAlign: 'center',
          }}
        >
          {t('preview.banner')} <strong>{previewState}</strong>
        </div>
      )}

      <div className="dp-shell__body">
        {(effectiveRoute === '/' || isPreview) && (
          <MarketplacePage previewState={previewState} />
        )}
        {effectiveRoute === '/dashboard' && <DashboardPage />}
        {isAdminRoute && (
          <AdminPage activePath={effectiveRoute} onNavigate={navigate} />
        )}
      </div>
    </div>
  );
}

export default function AppShell() {
  const config = useConfig();

  return (
    <KeycloakProvider config={config}>
      <RouterProvider>
        <ShellContent />
      </RouterProvider>
    </KeycloakProvider>
  );
}
